module.exports = __webpack_public_path__ + "img/gld_gbt69_2000.prt.712e387b.jpg";